import { motion } from 'framer-motion';

export default function RichTextSection({ section }) {
  const { title, body } = section;
  if (!body && !title) return null;

  return (
    <section className="py-12 sm:py-16" data-testid="section-rich-text">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.35 }}
        >
          {title && <h2 className="font-display text-xl sm:text-2xl font-medium tracking-[-0.015em] text-ink mb-6">{title}</h2>}
          {body && (
            <div
              className="prose prose-sm max-w-none"
              dangerouslySetInnerHTML={{ __html: body }}
            />
          )}
        </motion.div>
      </div>
    </section>
  );
}
